module.exports = __webpack_public_path__ + "img/front_6.f2adceb7.svg";